/**
 * Props for the HighlightPopup component.
 */
export type HighlightPopupProps = {
  /** Comment data containing text and emoji */
  comment: { text: string; emoji: string };
};

/**
 * Popup component to display highlight comments in PDF viewers.
 *
 * Shows the comment text with an optional emoji prefix.
 * Returns null if the comment text is empty.
 *
 * @param props - Component props
 * @returns Popup element or null if no comment text
 *
 * @example
 * ```tsx
 * <Popup popupContent={<HighlightPopup comment={{ text: "Important!", emoji: "📌" }} />}>
 *   <Highlight ... />
 * </Popup>
 * ```
 */
export const HighlightPopup = ({ comment }: HighlightPopupProps) =>
  comment.text ? (
    <div className="Highlight__popup">
      {comment.emoji} {comment.text}
    </div>
  ) : null;

export default HighlightPopup;
